import * as React from 'react';
import { Button, Modal, Row, message, Layout, Popover, Checkbox, Tag, Tooltip, Icon, DatePicker } from 'antd';
import bankDefault from '../../../assets/imgs/bankLogo/bank_default.png';
import bankBeijing from '../../../assets/imgs/bankLogo/bank_beijing.png';
import bankHuaxia from '../../../assets/imgs/bankLogo/bank_huaxia.png';
import bankJiaotong from '../../../assets/imgs/bankLogo/bank_jiaotong.png';
import bankPingan from '../../../assets/imgs/bankLogo/bank_pingan.png';
import bankShanghai from '../../../assets/imgs/bankLogo/bank_shanghai.png';
import bankXingye from '../../../assets/imgs/bankLogo/bank_xingye.png';
import bankZhaoshang from '../../../assets/imgs/bankLogo/bank_zhaoshang.png';
import bankZhejiang from '../../../assets/imgs/bankLogo/bank_zhejiang.png';
import bankGongshang from '../../../assets/imgs/bankLogo/bank_gongshang.png';
import bankGuangda from '../../../assets/imgs/bankLogo/bank_guangda.png';
import bankJianshe from '../../../assets/imgs/bankLogo/bank_jianshe.png';
import bankMinsheng from '../../../assets/imgs/bankLogo/bank_minsheng.png';
import bankNongye from '../../../assets/imgs/bankLogo/bank_nongye.png';
import bankChina from '../../../assets/imgs/bankLogo/bank_china.png';
import bankYouzheng from '../../../assets/imgs/bankLogo/bank_youzheng.png';
import I18N from 'src/services/I18NService';
import WalletService, {
  IAccountInfo,
  ICardInfo,
  IOrderSearch,
  IOrderResult,
  EAccountMemberType,
  ERegisterStep,
  PhotoOCRState,
  IAccountEditRecord,
  IAccountEditRecordResult,
} from 'src/services/WalletService';
import './wallet.css';
import * as moment from 'moment';
import Table, { ColumnProps } from 'antd/lib/table';
import { PaginationProps } from 'antd/lib/pagination';
import FileService from 'src/services/FileService';
import { RangePickerValue } from 'antd/lib/date-picker/interface';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { GetCashForm } from 'src/components/common/CreateGetCashForm';
import { AccountSupplementForm } from 'src/components/common/AccountSupplementForm';
import { ModifyMobileForm } from 'src/components/common/ModifyMobileForm';
import { ModifyAccountForm } from 'src/components/common/ModifyAccountForm';

const { RangePicker } = DatePicker;

interface IWalletDetailPageProps {
  userInfo?: IAgentInfo | IDrugStoreInfo;
  /** [企业账户|个人账户]账户数组 */
  accounts: IAccountInfo[];
  /** 前往绑卡页面 */
  goToBindPage: () => void;
  /** 前往注册页面 */
  goRegisterPage: (type: EAccountMemberType) => void;
  /** 刷新当前页面数据 */
  refreshAccounts: () => void;
}

interface IWalletDetailPageState {
  /** 当前激活的账户 */
  activeAccount: IAccountInfo;
  /** 控制账号切换pop 显示 */
  accountPopVisible: boolean;
  /** 控制切换默认账号二次确认弹窗 */
  accountConfirmVisible: boolean;
  /** 控制解绑模态窗显示 */
  unBindVisible: boolean;
  /** 解绑loading */
  unBindLoading: boolean;
  /** 控制提现模态窗显示 */
  getCashVisible: boolean;
  /** 提现loading */
  getCashLoading: boolean;
  /** 需要[解绑|提现]的卡 */
  selectedCard: ICardInfo | undefined;
  /** 账户余额 */
  balance: number;
  /** 已绑定的银行卡列表 */
  bankCards: ICardInfo[];
  /** 是否正在查询 */
  searchLoading: boolean;
  /** 是否正在导出 */
  exportLoading: boolean;
  /** 交易时间范围 */
  rangeDate: {
    startDate: string;
    endDate: string;
  };
  /** 交易明细列表 */
  orderRecords: IOrderResult[];
  /** table列表项配置 */
  columns: Array<ColumnProps<IOrderResult>>;
  /** 分页配置 */
  pagination: PaginationProps;
  /** 华通 - 认证要素完备性检查 */
  authenticateValid: boolean;
  /** 华通 - 影印件是否完备 */
  picturesValid: boolean;
  /** 通联 - 营业执照，组织机构代码张，税务登记证识别状态 */
  tonglianBusinessPhotocopyStatus: PhotoOCRState;
  /** 通联 - 法人身份证识别状态 */
  tonglianIdCardPhotocopyStatus: PhotoOCRState;
  /** 通联 - OCR错误详情 */
  tonglianOCRDetail?: string;
  /** 控制资料完善模态窗显示 */
  completeVisible: boolean;
  /** 修改手机号模态窗显示 */
  mobileModalVisible: boolean;
  /** 是否显示手续费提示 */
  showHandlingFeeTip: boolean;
  /** 是否修改账号信息 */
  accountModalVisible: boolean;
  /** 企业账户修改核查结果 */
  examineResult: IAccountEditRecordResult | undefined;
}

class WalletDetailPage extends React.Component<IWalletDetailPageProps, IWalletDetailPageState> {
  private walletService = WalletService;
  /** 银行Logo列表 */
  private bankLogoList: Array<{ name: string; path: string }> = [
    { name: 'default', path: bankDefault },
    { name: '北京银行', path: bankBeijing },
    { name: '华夏银行', path: bankHuaxia },
    { name: '交通银行', path: bankJiaotong },
    { name: '平安银行', path: bankPingan },
    { name: '上海银行', path: bankShanghai },
    { name: '兴业银行', path: bankXingye },
    { name: '招商银行', path: bankZhaoshang },
    { name: '浙江银行', path: bankZhejiang },
    { name: '工商银行', path: bankGongshang },
    { name: '光大银行', path: bankGuangda },
    { name: '建设银行', path: bankJianshe },
    { name: '民生银行', path: bankMinsheng },
    { name: '农业银行', path: bankNongye },
    { name: '中国银行', path: bankChina },
    { name: '中国邮政', path: bankYouzheng },
  ];
  /** 日期格式 */
  readonly dateFormat = 'YYYY-MM-DD';
  /** 账户绑定的手机号是否变化 */
  private mobileChanged = false;

  constructor(props: IWalletDetailPageProps) {
    super(props);
    const today = moment();
    // 最近7天日期
    const last7 = moment().subtract(6, 'days');
    // 表格列配置
    const columns: Array<ColumnProps<IOrderResult>> = [
      {
        title: '支付时间',
        key: 'created_time',
        dataIndex: 'created_time',
        align: 'center',
      },
      {
        title: '流水号',
        key: 'trade_no',
        dataIndex: 'trade_no',
        align: 'center',
      },
      {
        title: '业务订单号',
        key: 'order_no',
        dataIndex: 'order_no',
        align: 'center',
      },
      {
        title: '金额',
        key: 'amount_changed',
        dataIndex: 'amount_changed',
        align: 'center',
      },
      {
        title: '账户余额',
        key: 'amount',
        dataIndex: 'amount',
        align: 'center',
      },
      {
        title: '类型',
        key: 'trade_type',
        dataIndex: 'trade_type',
        align: 'center',
      },
      {
        title: '支付方',
        key: 'extend_info',
        dataIndex: 'extend_info',
        align: 'center',
      },
    ];
    // 将默认收款账户设置为当前激活账户
    const { accounts } = this.props;
    let activeAccount = accounts.find((account) => !!account.is_default && account.step === ERegisterStep.Opened);
    if (!activeAccount) {
      activeAccount = accounts.find((account) => account.step === ERegisterStep.Opened);
    }
    this.state = {
      activeAccount,
      accountPopVisible: false,
      accountConfirmVisible: false,
      unBindVisible: false,
      unBindLoading: false,
      getCashVisible: false,
      getCashLoading: false,
      selectedCard: undefined,
      bankCards: [],
      balance: 0,
      searchLoading: false,
      exportLoading: false,
      rangeDate: {
        startDate: last7.format(this.dateFormat),
        endDate: today.format(this.dateFormat),
      },
      orderRecords: [],
      columns,
      pagination: { pageSize: 20 },
      authenticateValid: true,
      picturesValid: true,
      completeVisible: false,
      mobileModalVisible: false,
      accountModalVisible: false,
      tonglianBusinessPhotocopyStatus: PhotoOCRState.OCRSuccess,
      tonglianIdCardPhotocopyStatus: PhotoOCRState.OCRSuccess,
      showHandlingFeeTip: true,
      examineResult: undefined,
    } as IWalletDetailPageState;
  }

  async componentDidMount() {
    const { activeAccount } = this.state;
    const accountId = activeAccount.id as string;
    if (activeAccount.member_type === EAccountMemberType.Enterprise) {
      this.fetchEditAccountExamineResult();
    }
    this.getBankCards(accountId);
    this.getBalance(accountId);
    this.searchRecords(accountId);
    this.fetchSupplementCheck(accountId);
  }

  componentWillUnmount() {}

  /**
   * 根据type 获取对应的账号信息
   * @param type
   */
  private getAccount(type: EAccountMemberType = EAccountMemberType.Individual) {
    const { accounts } = this.props;
    return accounts.find((a) => a.member_type === type);
  }

  /**
   * 获取关联的银行卡(过滤掉已解除的银行卡)
   */
  async getBankCards(accountId: string) {
    this.setState({ bankCards: [] });
    const res = await this.walletService.fetchBankCards(accountId);
    const bankCards = res.filter((item) => item.card_state === 1);
    bankCards.forEach((item) => {
      item.logo = this.getBankLogo(item.bank_name);
      item.maskCardNo = this.getMaskCardNo(item.card_no);
    });
    this.setState({ bankCards });
  }

  /**
   * 获取账号余额
   */
  async getBalance(accountId: string) {
    const balance = await this.walletService.fetchBalance(accountId);
    this.setState({ balance });
  }

  /**
   * 根据银行名称匹配银行logo
   * @param name
   */
  getBankLogo(name: string): string {
    let logoPath = '';
    const matchedItem = this.bankLogoList.find((item) => name.indexOf(item.name) !== -1);
    if (!!matchedItem) {
      logoPath = matchedItem.path;
    } else {
      logoPath = this.bankLogoList[0].path;
    }
    return logoPath;
  }

  /**
   * 获取脱敏银行号
   * @param cardNo
   */
  getMaskCardNo(cardNo: string): string {
    let result = '';
    if (typeof cardNo === 'string') {
      result = cardNo.substr(0, cardNo.length - 8) + '****' + cardNo.substr(cardNo.length - 4);
    }
    return result;
  }

  getMaskMobile(): string {
    let result = '';
    const { activeAccount } = this.state;
    const { phone } = activeAccount;
    if (phone) {
      result = result = phone.substr(0, phone.length - 8) + '****' + phone.substr(phone.length - 4);
    }
    return result;
  }

  /**
   * 解绑银行卡
   */
  handleUnbindCard = async () => {
    const { selectedCard } = this.state;
    if (!!selectedCard) {
      this.setState({ unBindLoading: true });
      const accountId = this.state.activeAccount.id as string;
      const isSucceed = await this.walletService.unbindBankCard(accountId, selectedCard.card_no);
      this.setState({ unBindLoading: false });
      if (isSucceed) {
        message.success('解绑成功');
        this.closeUnbindModal();
        // 重新获取绑定银行卡列表
        this.getBankCards(accountId);
      }
    }
  };

  /**
   * 显示解绑模态框
   */
  showUnbindModal = (card: ICardInfo) => {
    this.setState({ selectedCard: card, unBindVisible: true });
  };

  /**
   * 关闭解卡模态框
   */
  closeUnbindModal = () => {
    this.setState({
      unBindVisible: false,
      selectedCard: undefined,
      unBindLoading: false,
    });
  };

  /** 检查要素完整性和影印检查 */
  private async fetchSupplementCheck(accountId: string) {
    const res = await WalletService.fetchAccountSupplementCheck(accountId);
    return new Promise<void>((resolve) => {
      this.setState(
        {
          authenticateValid: res.authenticate_elements_ok,
          picturesValid: res.pictures_ok,
          tonglianBusinessPhotocopyStatus: res.tonglian_business_photocopy_status,
          tonglianIdCardPhotocopyStatus: res.tonglian_id_card_photocopy_status,
          tonglianOCRDetail: res.tonglian_photocopy_ocr_failed_reason,
        },
        () => resolve()
      );
    });
  }

  /**
   * 显示提现模态窗
   */
  showGetCashModal = async () => {
    // 先判断是否有绑定的银行卡
    const { bankCards, activeAccount } = this.state;
    const { userInfo } = this.props;
    const accountId = activeAccount.id as string;
    const uuid = userInfo ? userInfo.admin_uuid : '';
    if (bankCards.length > 0) {
      // 已经绑定银行卡 => 检查要素完整性和影印检查
      // 调用接口, 后台检查要素完整性和影印检查
      await this.fetchSupplementCheck(accountId);
      await this.hasHandlingFee(uuid);
      const shouldShow = this.shouldShowSupplement();
      if (shouldShow === 'pending') {
        message.warning('企业账户提现需提交营业执照和法人身份证影印件，您提交的影印件正在审核中');
      } else if (shouldShow === true) {
        message.warning('企业账户提现需提交营业执照和法人身份证影印件，请先提交影印件');
      } else {
        // 要素完整性和影印验证成功 => 打开提现弹窗
        // 暂时取第一张银行卡作为提现卡
        const selectedCard = bankCards[0];
        this.setState({ selectedCard, getCashVisible: true });
        // 重新获取账户余额
        this.getBalance(accountId);
      }
    } else {
      // 自动跳转绑卡页面
      this.props.goToBindPage();
    }
  };

  /** 是否含有提现手续费 */
  hasHandlingFee = async (uuid: string | undefined) => {
    if (!!uuid) {
      const res = await WalletService.fetchHasHandlingFee(uuid);
      this.setState({
        showHandlingFeeTip: res,
      });
    }
  };

  shouldShowSupplement = (): 'pending' | true | false => {
    const { authenticateValid, picturesValid, tonglianBusinessPhotocopyStatus, tonglianIdCardPhotocopyStatus, activeAccount } = this.state;
    const tonglianPictureOK = tonglianIdCardPhotocopyStatus === PhotoOCRState.OCRSuccess && tonglianBusinessPhotocopyStatus === PhotoOCRState.OCRSuccess;

    const isTonglian = activeAccount.depository_unit === 'TONGLIAN';
    const pictureOk = isTonglian ? tonglianPictureOK : picturesValid;
    if (!authenticateValid || !pictureOk) {
      const picturePending =
        isTonglian && (tonglianBusinessPhotocopyStatus === PhotoOCRState.OCRPending || tonglianIdCardPhotocopyStatus === PhotoOCRState.OCRPending);

      if (picturePending) {
        return 'pending';
      } else {
        return true;
      }
    }

    return false;
  };

  showSupplementModal = () => {
    const shouldShow = this.shouldShowSupplement();
    if (shouldShow === true || shouldShow === 'pending') {
      if (shouldShow === 'pending') {
        message.warning('您提交的影印资料还在审核中，请稍后再试！');
      } else {
        // 要素完整性和影印验证失败 => 弹窗补充
        this.setState({ completeVisible: true });
      }

      return true;
    }

    return false;
  };

  /**
   * 显示修改手机号模态窗
   * @returns
   */
  showMobileModal = () => {
    this.setState({ mobileModalVisible: true });
  };

  /** 显示修改账户模态窗 */
  showAccountModal = () => {
    this.setState({ accountModalVisible: true });
  };

  /**
   * 关闭提现模态框
   */
  closeGetCashModal = () => {
    const { activeAccount } = this.state;
    this.setState({
      getCashVisible: false,
      selectedCard: undefined,
    });
    // 重新获取账户余额
    const accountId = activeAccount.id as string;
    this.getBalance(accountId);
  };

  /**
   * 关闭资料完善模态框
   */
  closeSupplementModal = () => {
    this.setState({
      completeVisible: false,
    });

    // 重新获取账户状态
    const { activeAccount } = this.state;
    const accountId = activeAccount.id as string;
    this.fetchSupplementCheck(accountId);
  };

  /**
   * 关闭手机修改模态框
   */
  closeMobileModal = () => {
    this.setState({
      mobileModalVisible: false,
    });
    if (this.mobileChanged) {
      // 账户手机状态变化 => 重新获取账户信息
      this.props.refreshAccounts();
    }
  };

  /** 查询企业用户信息变更记录 */
  fetchEditAccountExamineResult = async () => {
    const examineResult = await this.walletService.fetchAccountExamine();
    this.setState({ examineResult });
  };

  updateExamineResultSuccess = async () => {
    this.fetchEditAccountExamineResult();
    this.props.refreshAccounts();
  };

  /**
   * 关闭账号修改模态框
   */
  closeAccountModal = () => {
    this.setState({
      accountModalVisible: false,
    });
  };

  /**
   * 切换当前激活账号
   */
  toggleAccount(type: EAccountMemberType) {
    const { activeAccount } = this.state;
    if (activeAccount.member_type !== type) {
      const toggleAccount = this.getAccount(type);

      if (!!toggleAccount) {
        this.setState({ activeAccount: toggleAccount });
        const accountId = toggleAccount.id as string;
        this.getBankCards(accountId);
        this.getBalance(accountId);
        this.searchRecords(accountId);
        this.fetchSupplementCheck(accountId);
        if (toggleAccount.member_type === EAccountMemberType.Enterprise) {
          this.fetchEditAccountExamineResult();
        }
      }
    }
    this.setState({ accountPopVisible: false });
  }

  /**
   * 处理默认收款账户checkbox变化 => 弹出二次确认框
   */
  handleDefaultAccountChange = () => {
    this.setState({ accountConfirmVisible: true });
  };

  /**
   * 设置默认收款账号
   */
  setDefaultAccount = async () => {
    const { activeAccount } = this.state;
    const accountId = activeAccount.id as string;
    const isSucceed = await this.walletService.setDefaultAccount(accountId);
    if (isSucceed) {
      message.success(I18N.get('common_save_success'));
      activeAccount.is_default = true;
      const unActiveAccountType = activeAccount.member_type === EAccountMemberType.Individual ? EAccountMemberType.Enterprise : EAccountMemberType.Individual;
      const unActiveAccount = this.getAccount(unActiveAccountType);
      if (!!unActiveAccount) {
        unActiveAccount.is_default = false;
      }
      this.setState({ accountConfirmVisible: false, activeAccount });
    } else {
      message.error(I18N.get('err_save_failure'));
    }
  };

  /**
   * 关闭默认账号切换二次弹窗
   */
  closeAccountConfirmModal = () => {
    this.setState({ accountConfirmVisible: false });
  };

  handleRangeChange = (dates: RangePickerValue, dateStrings: [string, string]) => {
    const { rangeDate } = this.state;
    const tempDates = dates as [moment.Moment, moment.Moment];
    const diffDate = tempDates[1].diff(tempDates[0], 'days', true);
    let startDate = dateStrings[0];
    let endDate = dateStrings[1];
    // 只允许查询1个月的记录
    if (diffDate > 30) {
      // 大于1个月时，还原原数据并提示报错
      startDate = rangeDate.startDate;
      endDate = rangeDate.endDate;
      message.error('每次最多只能查询1个月的记录');
    }
    this.setState({
      rangeDate: {
        startDate,
        endDate,
      },
    });
  };

  /**
   * 查询交易记录
   */
  searchRecords = async (accountId: string, offset: number = 0, limit: number = 20) => {
    let result: IOrderResult[] = [];
    this.setState({ searchLoading: true });
    const { rangeDate, pagination } = this.state;
    const param: IOrderSearch = {
      created_date__gte: rangeDate.startDate,
      created_date__lte: rangeDate.endDate,
      offset,
      limit,
    };
    const res = await this.walletService.fetchOrderRecords(accountId, param);
    if (!!res && Array.isArray(res.results)) {
      result = res.results.slice();
      pagination.total = res.count;
      if (!offset) {
        pagination.current = 1;
        this.setState({ pagination });
      }
    }
    this.setState({ searchLoading: false, orderRecords: result });
  };

  /**
   * 处理分页事件
   */
  handleTableOnChange = (pagination: PaginationProps, filters: any, sorter: any) => {
    const pager: PaginationProps = { ...this.state.pagination };
    const { activeAccount } = this.state;
    const accountId = activeAccount.id as string;
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    if (!!pager.current && pager.current > 0) {
      this.searchRecords(accountId, (pager.current - 1) * Number(pagination.pageSize), pagination.pageSize);
    }
  };

  /**
   * 导出交易明细excel
   */
  exportExcel = async () => {
    const { pagination, rangeDate, activeAccount } = this.state;
    if (!!pagination.total) {
      this.setState({ exportLoading: true });
      const param: IOrderSearch = {
        created_date__gte: rangeDate.startDate,
        created_date__lte: rangeDate.endDate,
        offset: 0,
        limit: pagination.total,
      };
      const accountId = activeAccount.id as string;
      const res = await this.walletService.fetchOrderRecords(accountId, param);
      if (!!res && Array.isArray(res.results)) {
        try {
          FileService.tradeOrderExport(rangeDate, res.results);
        } catch (error) {
          console.error(error);
          message.error(I18N.get('err_export_failure'));
        }
      } else {
        message.error(I18N.get('err_export_failure'));
      }
      this.setState({ exportLoading: false });
    }
  };

  /** 不可以选择的日期 */
  disabledDate = (current: moment.Moment) => {
    return current < moment().add(-1, 'month').endOf('day') || current > moment().endOf('day');
  };

  render() {
    const { Sider, Content } = Layout;
    const { userInfo } = this.props;
    const {
      unBindVisible,
      bankCards,
      unBindLoading,
      balance,
      getCashVisible,
      selectedCard,
      searchLoading,
      rangeDate,
      orderRecords,
      pagination,
      columns,
      exportLoading,
      activeAccount,
      accountPopVisible,
      accountConfirmVisible,
      completeVisible,
      authenticateValid,
      picturesValid,
      tonglianBusinessPhotocopyStatus,
      tonglianIdCardPhotocopyStatus,
      tonglianOCRDetail,
      mobileModalVisible,
      accountModalVisible,
      showHandlingFeeTip,
      examineResult,
    } = this.state;
    const { startDate, endDate } = rangeDate;
    const individualAccount = this.getAccount();
    const enterpriseAccount = this.getAccount(EAccountMemberType.Enterprise);
    const individualDeactive = !individualAccount || individualAccount.step < ERegisterStep.Opened;
    const enterpriseDeactive = !enterpriseAccount || enterpriseAccount.step < ERegisterStep.Opened;
    const popContent = (
      <div style={{ width: 150 }}>
        {individualDeactive && (
          <div className="pop-row" onClick={() => this.props.goRegisterPage(EAccountMemberType.Individual)}>
            开通个人账户
          </div>
        )}
        {!individualDeactive && (
          <div className="pop-row" onClick={() => this.toggleAccount(EAccountMemberType.Individual)}>
            个人账户
          </div>
        )}
        {enterpriseDeactive && (
          <div className="pop-row" onClick={() => this.props.goRegisterPage(EAccountMemberType.Enterprise)}>
            开通企业账户
          </div>
        )}
        {!enterpriseDeactive && (
          <div className="pop-row" onClick={() => this.toggleAccount(EAccountMemberType.Enterprise)}>
            企业账户
          </div>
        )}
      </div>
    );

    const isReadonly = !((!!examineResult && examineResult.status !== 'PENDING') || !examineResult);

    return (
      <div className="detailPage">
        <Layout style={{ background: '#fff' }}>
          <Sider width={340} className="sider">
            <div className="sider-hd">
              <div className="account-wrap">
                <div className="account-row">
                  {activeAccount.member_type === EAccountMemberType.Individual && (
                    <span>
                      <Icon type="user" style={{ color: '#1FB8CD', marginRight: 5 }} />
                      {activeAccount.name}
                    </span>
                  )}
                  {activeAccount.member_type === EAccountMemberType.Enterprise && (
                    <span>
                      <Icon type="bank" style={{ color: '#1FB8CD', marginRight: 5 }} />
                      {activeAccount.name}
                    </span>
                  )}
                  <Popover
                    overlayClassName="account-popover"
                    content={popContent}
                    trigger="click"
                    placement="bottomLeft"
                    visible={accountPopVisible}
                    onVisibleChange={(visible: boolean) => this.setState({ accountPopVisible: visible })}
                  >
                    <span className="link-btn">切换账户</span>
                  </Popover>
                </div>
                <div className="account-row">
                  <Checkbox disabled={activeAccount.is_default} checked={activeAccount.is_default} onChange={this.handleDefaultAccountChange}>
                    设为默认收款账户
                  </Checkbox>
                  {activeAccount.member_type === EAccountMemberType.Enterprise && activeAccount.step === 5 && (
                    <span>
                      {!!examineResult && (
                        <span>
                          {examineResult.status === 'PENDING' && (
                            <span>
                              <Tag>审核中</Tag>
                              <span className="link-btn" onClick={this.showAccountModal}>
                                查看
                              </span>
                            </span>
                          )}
                          {examineResult.status === 'SUCCESS' && <Tag color="green">变更成功</Tag>}
                          {examineResult.status === 'FAIL' && (
                            <Tooltip title={examineResult.fail_reason}>
                              <Tag color="red">变更失败</Tag>
                            </Tooltip>
                          )}
                          {examineResult.status !== 'PENDING' && (
                            <span className="link-btn" onClick={this.showAccountModal}>
                              编辑
                            </span>
                          )}
                        </span>
                      )}
                      {!examineResult && (
                        <span className="link-btn" onClick={this.showAccountModal}>
                          编辑
                        </span>
                      )}
                    </span>
                  )}
                </div>
                {!!this.getMaskMobile() && (
                  <div className="account-row" style={{ justifyContent: 'flex-start' }}>
                    <label style={{ marginRight: 10, color: '#555555' }}>手机号:</label>
                    <span style={{ marginRight: 20 }}>{this.getMaskMobile()}</span>
                    <span className="link-btn" onClick={this.showMobileModal}>
                      更换
                    </span>
                  </div>
                )}
                {this.shouldShowSupplement() === true && (
                  <div className="account-row">
                    <Button type="primary" onClick={this.showSupplementModal}>
                      提交影印件
                    </Button>
                  </div>
                )}
                {this.shouldShowSupplement() === 'pending' && (
                  <div className="account-row">
                    <Button type="primary" disabled={true}>
                      影印件审核中
                    </Button>
                  </div>
                )}
              </div>
              <div className="balance-wrap">
                <div className="header">
                  <span>余额(元)</span>
                  <Button type="primary" onClick={this.showGetCashModal}>
                    提现
                  </Button>
                </div>
                <div className="content">{balance.toFixed(2)}</div>
              </div>
            </div>
            <div className="sider-bd">
              <div className="header">绑定银行卡</div>
              <div className="content">
                {/* 个人账户且没有关联银行卡时才显示添加银行卡按钮 */}
                {!bankCards.length && activeAccount.member_type === EAccountMemberType.Individual && (
                  <Button type="dashed" block={true} onClick={this.props.goToBindPage}>
                    + 添加银行卡
                  </Button>
                )}
                {bankCards.map((card) => {
                  return (
                    <div key={card.maskCardNo} className="bankCard">
                      <div className="bankCard-lt">
                        <img src={card.logo} />
                      </div>
                      <div className="bankCard-rt">
                        <div className="bankCard-rt-hd">
                          <span className="left">{card.bank_name}</span>
                          {/* 个人账户才显示解绑按钮 */}
                          {activeAccount.member_type === EAccountMemberType.Individual && (
                            <span
                              className="link-btn"
                              onClick={() => {
                                this.showUnbindModal(card);
                              }}
                            >
                              解绑
                            </span>
                          )}
                        </div>
                        <div className="bankCard-rt-bd">{card.maskCardNo}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Sider>
          <Content>
            <Row gutter={0} type="flex" justify="center" align="middle">
              <label style={{ marginRight: 10 }}>交易时间:</label>
              <RangePicker
                format={this.dateFormat}
                allowClear={false}
                disabledDate={this.disabledDate}
                value={[moment(startDate, this.dateFormat), moment(endDate, this.dateFormat)] as RangePickerValue}
                onChange={this.handleRangeChange}
              />
              <Button type="primary" style={{ marginLeft: 30 }} onClick={() => this.searchRecords(activeAccount.id as string)} loading={searchLoading}>
                {I18N.get('common_search')}
              </Button>
            </Row>
            <div style={{ margin: '36px 0 0 30px' }}>
              <Row gutter={0} type="flex" justify="space-between" align="middle" style={{ marginBottom: 20, color: '#1FB8CD' }}>
                <div>共搜索到{pagination.total || 0}条数据</div>
                <Button onClick={this.exportExcel} loading={exportLoading}>
                  {I18N.get('common_export')}
                </Button>
              </Row>
              <Table
                loading={searchLoading}
                columns={columns}
                rowKey="trade_no"
                pagination={pagination}
                dataSource={orderRecords}
                onChange={this.handleTableOnChange}
                locale={{ emptyText: '暂无数据' }}
              />
            </div>
          </Content>
        </Layout>
        {/* 解绑二次确认模态窗 */}
        <Modal centered={true} title="解绑" visible={unBindVisible} destroyOnClose={true} footer={null} onCancel={this.closeUnbindModal}>
          <div style={{ marginBottom: 30, textAlign: 'center', color: '#222' }}>请您确认是否解绑此银行卡！</div>
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" loading={unBindLoading} onClick={this.handleUnbindCard}>
              {I18N.get('common_ok')}
            </Button>
            <Button style={{ marginLeft: 20 }} type="default" onClick={this.closeUnbindModal}>
              {I18N.get('common_cancel')}
            </Button>
          </div>
        </Modal>
        {/* 提现模态窗 */}
        <Modal centered={true} title="提现" visible={getCashVisible} destroyOnClose={true} footer={null} onCancel={this.closeGetCashModal}>
          {!!selectedCard && (
            <GetCashForm
              cardInfo={selectedCard}
              account={activeAccount}
              balance={balance}
              showHandlingFeeTip={showHandlingFeeTip}
              closeModal={() => this.closeGetCashModal()}
            />
          )}
        </Modal>
        {/* 默认账号切换确认模态窗 */}
        <Modal centered={true} title="提示" visible={accountConfirmVisible} destroyOnClose={true} footer={null} onCancel={this.closeAccountConfirmModal}>
          <Row type="flex" align="middle" justify="center" style={{ margin: 0 }}>
            请您选择是否确定将
            <span>{activeAccount.member_type === EAccountMemberType.Individual ? '个人账户' : '企业账户'}</span>
            设置默认收款账户！
          </Row>
          <Row type="flex" align="middle" justify="center" style={{ margin: '30px 0 0 0' }}>
            <Button type="primary" onClick={this.setDefaultAccount}>
              {I18N.get('common_ok')}
            </Button>
            <Button style={{ marginLeft: 20 }} onClick={this.closeAccountConfirmModal}>
              {I18N.get('common_cancel')}
            </Button>
          </Row>
        </Modal>
        {/* 提现模态窗 */}
        <Modal centered={true} title="资料完善" width={600} visible={completeVisible} destroyOnClose={true} footer={null} onCancel={this.closeSupplementModal}>
          {
            <AccountSupplementForm
              userInfo={userInfo}
              account={activeAccount}
              authenticateValid={authenticateValid}
              picturesValid={picturesValid}
              tonglianBusinessPhotocopyStatus={tonglianBusinessPhotocopyStatus}
              tonglianIdCardPhotocopyStatus={tonglianIdCardPhotocopyStatus}
              tonglianOCRDetail={tonglianOCRDetail}
              closeModal={this.closeSupplementModal}
            />
          }
        </Modal>
        {/* 提现模态窗 */}
        <Modal
          centered={true}
          title="更换钱包手机号"
          width={440}
          visible={mobileModalVisible}
          destroyOnClose={true}
          footer={null}
          onCancel={this.closeMobileModal}
        >
          {
            <ModifyMobileForm
              userInfo={userInfo}
              account={activeAccount}
              mobileChanged={(changed: boolean) => (this.mobileChanged = changed)}
              closeModal={this.closeMobileModal}
            />
          }
        </Modal>
        {/* 编辑账户信息 */}
        <Modal
          centered={true}
          title="企业账户编辑"
          width={540}
          visible={accountModalVisible}
          destroyOnClose={true}
          footer={null}
          onCancel={this.closeAccountModal}
        >
          {
            <div style={{ height: '70vh', overflow: 'hidden', overflowY: 'auto' }}>
              <ModifyAccountForm
                account={activeAccount}
                // 根据状态查看是否可以查看还是修改
                isReadonly={isReadonly}
                examineRecord={examineResult}
                closeModal={this.closeAccountModal}
                submitEditInfo={this.updateExamineResultSuccess}
              />
            </div>
          }
        </Modal>
      </div>
    );
  }
}

export default WalletDetailPage;



// WEBPACK FOOTER //
// ./src/components/views/Wallet/WalletDetailPage.tsx